import { HealthcareProviderP1Configuration } from '@dreryk/egabinet-p1-frontend-api';

import { UseCqrsQueryResult } from '@dreryk/command-query-react-common';
import { BindingCreator } from '@dreryk/react-common';
import { P1IdentifierInput } from '@dreryk/react-components';

import { P1IdentifierFormFields } from '../P1IdentifierForm';

type P1IdentifierFieldProps = {
   readonly register: BindingCreator<P1IdentifierFormFields>;
   readonly p1ConfigurationLoading: UseCqrsQueryResult<HealthcareProviderP1Configuration>['loading'];
};

const P1IdentifierField = (props: P1IdentifierFieldProps): JSX.Element => {
   return (
      <P1IdentifierInput
         disabled={props.p1ConfigurationLoading}
         placeholder='healthCareInstitution:communicationWithP1:p1Identifier:placeholder'
         label={
            props.p1ConfigurationLoading
               ? 'healthCareInstitution:communicationWithP1:p1Identifier:loading'
               : 'healthCareInstitution:communicationWithP1:p1Identifier:label'
         }
         controller={props.register('p1Identifier', {
            required: true,
         })}
         testId={'p1Identifier'}
      />
   );
};

export { P1IdentifierField };
